import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from '@mos-cat/modal';
import MosButton from '@mos-front-components/public/es/components/MosButton/MosButton';
import AttentionIcon from 'src/assets/Attention.svg';

import { userChangedModalClose } from 'src/store/userChangedModal/actions';

import {
  userChangedModalSelector,
  userChangedModalPropTypes
} from './userChangedModalSelector';

import './UserChangedModal.pcss';

const UserChangedModal = ({
  visible,
  onCloseModal,
  handleUserChangedModalClose
}) => {
  const handleCancel = () => {
    if (onCloseModal) {
      onCloseModal();
    }

    handleUserChangedModalClose();
  };

  return (
    <Modal
      className="UserChangedModal"
      visible={visible}
      onCancel={handleCancel}
    >
      <AttentionIcon />
      <h1 className="UserChangedModal__header">Выход из учетной записи</h1>
      <p className="UserChangedModal__description">
        Произошел выход из учетной записи пользователя, либо учетная запись
        сменилась. Страница заявления будет перезагружена.
      </p>
      <MosButton primary onClick={handleCancel}>
        Закрыть
      </MosButton>
    </Modal>
  );
};

UserChangedModal.propTypes = {
  ...userChangedModalPropTypes,
  handleUserChangedModalClose: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func
};

UserChangedModal.defaultProps = {
  onCloseModal: null
};

const mapDispatchToProps = dispatch => ({
  handleUserChangedModalClose: () => dispatch(userChangedModalClose())
});

export default connect(
  userChangedModalSelector,
  mapDispatchToProps
)(UserChangedModal);
